var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.recipeList),function(recipe,index){return _c('recipe-item',{key:index,attrs:{"favourites":_vm.favourites,"recipe":recipe}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }